import { withPromise } from "../../../exports/core";
import { otto } from "../../../exports/nexus";

/**
 *
 *
 *
 */
export const getPageMergeId = async (): Promise<string> =>
  (await withPromise(otto.tracking.getPageMergeId(), { timeout: 100 }).catch(() => null)) ??
  "unknown";
